/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import AnchorButton from 'components/AnchorButton';
import { IMDB_TITLE_URL } from 'config/imdb';
import ImdbIcon from 'public/assets/svgs/icons/imdb.svg';

const Imdb = ({ id }) => (
  <>
    {id && (
      <AnchorButton
        anchorProps={{
          href: `${IMDB_TITLE_URL}/${id}`,
          target: '_blank',
          rel: 'noopener noreferrer'
        }}
        buttonProps={{
          title: 'IMDB',
          endIcon: (
            <ImdbIcon
              fill='currentColor'
              width='0.875em' />
          )
        }} />
    )}
  </>
);

export default Imdb;
